import axiosInstance from "../../../axios";
export const getCourseTableService = async (object) => {
  console.log(object,"object here");
  try {
    const response = await axiosInstance.get(`/courses?courseName=${object.courseName}&category=${object.searchTermCatgeory}&pageLength=9999&pageNo=1`);
    console.log("Response data inside getCourseTableService:", response);
    return response?.data;
  } catch (error) {
    console.error("Error in getCourseTableService:", error);
    throw error;
  }
};
